(function () {
    RCDPW.isAdminSite = false;
    RCDPW.soUrl = 'https://stackoverflow.com/questions/tagged/ringcentral';
    RCDPW.faqUrl = 'https://ringcentral-faq.readthedocs.io/';
    RCDPW.blogUrl = 'https://medium.com/ringcentral-developers';
    RCDPW.goToCommunityUrl = '/go-to-community.html';
    RCDPW.legalUrl = 'https://www.ringcentral.com/legal.html';
    RCDPW.swUrl = 'https://service.ringcentral.com/';
    RCDPW.guideAppGalleryChecklistUrl = 'https://developers.ringcentral.com/guide/basics/app-gallery-checklist';
    RCDPW.guidelinesUrl = 'https://developers.ringcentral.com/guide/basics/partners/brand-guidelines';
    RCDPW.cancelTrailUrl = '/my-account.html?action=cancelTrial#/applications';
    RCDPW.legacyFreeSignUpUrl = '/free-sign-up';
    RCDPW.assetsDomain = 'https://netstorage.ringcentral.com';
    RCDPW.entries = {
        index: {href: '/', text: 'Home'},
        login: {href: '/login'},
        console: {text: 'Console', href: '/my-account.html'},
        createApp: {href: '/console/applications/create'},
        useCases: {href: '/overview'},
        apiProducts: {href: '/api-products'},
        apiProductsVoice: {href: '/api-products/voice'},
        apiProductsSMS: {href: '/api-products/sms'},
        apiProductsGlipMessaging: {href: '/api-products/team-messaging'},
        apiProductsMeetings: {href: '/api-products/meetings'},
        apiProductsFax: {href: '/api-products/fax'},
        apiProductsData: {href: '/api-products/data'},
        apiProductsConfiguration: {href: '/api-products/configuration'},
        apiProductsVideo: {href: '/api-products/video'},
        resourcesDataSheets: {text: 'Data sheets', href: '/resources#datasheets'},
        resourcesWhitepapers: {text: 'Whitepapers', href: '/resources#whitepapers'},
        resourcesVideos: {text: 'Videos', href: '/resources#videos'},
        apiAndDocs: {href: '/api-and-docs.html'},
        support: {href: '/support'},
        supportServices: {href: '/support/services'},
        supportCreateCase: {href: '/support/create-case'},
        supportCheckCase: {href: 'https://support.ringcentral.com/case.html'},
        gettingStarted: {text: 'Getting started', href: '/guide'},
        embeddableVoice: {href: '/embeddable-voice'},
        apiReference: {text: 'API Reference', href: '/api-reference'},
        sdks: {text: 'SDKs', href: '/guide/sdks'},
        chatbots: {text: 'Chatbots', href: '/library/chatbots.html'},
        freeTierSignUp: {href: '/sign-up'},
        community: {text: 'Community', href: '/community.html'},
        developerEvents: {text: 'Events', href: '/community/developer-events'},
        developerGuide: {text: 'Developer Guide', href: '/guide'},
        gameChangers: {text: 'Game Changers', href: '/gamechangers'},

        reqInv: {href: '/sign-up.html'},
        thankYouReqInv: {href: '/thank-you-request-invitation.html'},
        thankYouMarketoForms: {href: '/marketo/thank-you.html'},
        jsSdkGuide: {
            text: 'JS Developer Guide',
            href: '/library/js-sdk-guide.html'
        },
        tutorials: {text: 'Browse tutorials', href: '/tutorials.html'},
        engage: {
            apiProducts: {
                href: '/engage/api-products'
            },
            gameChangers: {
                href: '/engage/gamechangers'
            },
            digital: {
                href: '/engage/api-products/digital'
            },
            voice: {
                href: '/engage/api-products/voice'
            },
            apiReference: {
                href: '/engage/api-reference'
            },
            apiRefDigital: {
                href: '/engage/digital/api-reference'
            },
            apiRefVoice: {
                href: '/engage/voice/api-reference'
            },
            guide: {
                href: '/engage/guide'
            },
            guideDigitalSdks: {
                href: '/engage/digital/guide/sdks'
            },
            guideVoiceSdks: {
                href: '/engage/voice/guide/sdks'
            },
            guideDigital: {
                href: '/engage/digital/guide'
            },
            guideVoice: {
                href: '/engage/voice/guide'
            },
            community: {
                href: '/engage/community.html'
            },
            support: {
                href: '/engage/support'
            },
            supportCreateCase: {
                href: '/engage/support/create-case'
            },
            supportServices: {
                href: '/support/services'
            },
            developerEvents: {
                text: 'Events',
                href: '/community/developer-events'
            },
            embeddableVoice: {
                href: '/engage/embeddable-voice'
            },
        }
    };

    RCDPW.externalEntries = {
        apiChangeLog: {
            text: 'API changelog',
            href: '/guide/basics/changelog',
            target: '_blank',
            pageNameForMixpanel: 'ApiChangeLog'
        },
        faq: {
            text: 'FAQs',
            target: '_blank',
            href: RCDPW.faqUrl,
            pageNameForMixpanel: 'FAQ'
        },
        developerForum: {
            text: 'Developer Forum',
            target: '_blank',
            href: RCDPW.goToCommunityUrl,
            pageNameForMixpanel: 'DeveloperForum'
        },
        engageDeveloperForum: {
            text: 'Developer Forum',
            target: '_blank',
            href: RCDPW.goToCommunityUrl,
            pageNameForMixpanel: 'EngageDeveloperForum'
        },
        stackOverflow: {
            text: 'StackOverflow',
            target: '_blank',
            href: RCDPW.soUrl,
            pageNameForMixpanel: 'StackOverflow'
        },
        blog: {
            text: 'Blog',
            target: '_blank',
            href: RCDPW.blogUrl,
            pageNameForMixpanel: 'Blog'
        },
        appGallery: {
            text: 'App Gallery',
            target: '_blank',
            href: (RCDPW.apwUrl || 'https://www.ringcentral.com/') + 'apps/',
            pageNameForMixpanel: 'AppGallery'
        },
        caseStudies: {
            text: 'Case studies',
            href: 'https://www.ringcentral.com/whyringcentral/casestudies.html?product=16',
            target: '_blank',
            pageNameForMixpanel: 'Case Studies'
        },
        engageCaseStudies: {
            text: 'Case studies',
            href: 'https://www.ringcentral.com/whyringcentral/casestudies.html?product=14&product=11',
            target: '_blank',
            pageNameForMixpanel: 'Case Studies'
        },
        whitePapers: {
            text: 'Whitepapers',
            target: '_blank',
            href: 'https://www.ringcentral.com/resources/learning-center.html#whitepapers',
            pageNameForMixpanel: 'White Papers'
        },
        webinars: {
            text: 'Webinars',
            target: '_blank',
            href: 'https://go.ringcentral.com/Developer-Webinar-Series-Registration.html',
            pageNameForMixpanel: 'Webinars'
        },
        meetups: {
            text: 'Meetups',
            target: '_blank',
            href: 'https://go.ringcentral.com/developer-meetup-series-registration.html',
            pageNameForMixpanel: 'Meetups'
        },
        partnerProgram: {
            text: 'Partner Program',
            target: '_blank',
            href: 'https://www.ringcentral.com/partner/isv.html',
            pageNameForMixpanel: 'PartnerProgram'
        },
        SDKs: {
            cSharp: {
                text: 'C#',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral.net',
                pageNameForMixpanel: 'SDK:Github:C#'
            },
            iOS: {
                text: 'iOS/Swift',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-swift',
                pageNameForMixpanel: 'SDK:Github:Swift'
            },
            javaScript: {
                text: 'JavaScript',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-js',
                pageNameForMixpanel: 'SDK:Github:JavaScript'
            },
            java: {
                text: 'Java',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-java',
                pageNameForMixpanel: 'SDK:Github:Java'
            },
            php: {
                text: 'PHP',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-php',
                pageNameForMixpanel: 'SDK:Github:PHP'
            },
            python: {
                text: 'Python',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-python',
                pageNameForMixpanel: 'SDK:Github:Python'
            },
            ruby: {
                text: 'Ruby',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-ruby',
                pageNameForMixpanel: 'SDK:Github:Ruby'
            }
        },
        twitter: {
            text: 'Twitter',
            target: '_blank',
            href: 'https://twitter.com/RingCentralDevs',
            pageNameForMixpanel: 'Twitter'
        },
        github: {
            text: 'GitHub',
            target: '_blank',
            href: 'https://github.com/ringcentral/',
            pageNameForMixpanel: 'Github'
        },
        weavr: {
            text: 'Weavr',
            target: '_blank',
            href: 'https://weavrboards.com/ringcentraldevs',
            pageNameForMixpanel: 'Weavr'
        },
        widgets: {
            chromeKit: {
                text: 'Chrome Kit',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-embeddable-extension-factory'
            },
            firefoxKit: {
                text: 'Firefox Kit',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-embeddable-for-google-firefox-addon'
            },
            clickToDail: {
                text: 'Click-to-Dial',
                target: '_blank',
                href: 'https://github.com/ringcentral/ringcentral-c2d'
            }
        }
    };

    RCDPW.defaultPostLoginEntry = RCDPW.entries.console;
    RCDPW.helloWorldUrl = '/console/hello-world';
    RCDPW.forbiddenConfigs = {
        login: {
            urls: [
                {
                    href: RCDPW.entries.reqInv.href,
                    redirectTo: RCDPW.entries.index.href
                }
            ]
        },
        logout: [] //handled by backend
    };
    RCDPW.runConfig = [
        '$location', 'helpers', 'menuService', 'dpwStorage',
        function ($location, helpers, menuService, dpwStorage) {
            menuService.init();

            saveSessionWhenNeeded();

            function saveSessionWhenNeeded() {
                var previousUrlKey = 'previousUrl';

                if (helpers.isSafari()) {
                    $(window).on('beforeunload', function () {
                        manageSession();
                    });
                } else {
                    $(window).on('unload', function () {
                        manageSession();
                    });
                }

                function manageSession() {
                    if (shouldSaveSession()) {
                        return dpwStorage.setItem(previousUrlKey, location.href, true);
                    }
                    if (shouldClearSavedSession()) {
                        dpwStorage.removeItem(previousUrlKey);
                    }
                }

                function shouldSaveSession() {
                    return helpers.isApiRef() || isCreateAppPage();

                    function isCreateAppPage() {
                        var currentUrl = location.pathname + location.hash;
                        return _.startsWith(currentUrl, '/my-account.html#/new-app');
                    }
                }

                function shouldClearSavedSession() {
                    return (
                        location.pathname !== '/login' &&
                        location.pathname !== '/three-legged-callback.html'
                    );
                }
            }
        }
    ];
    RCDPW.RCProductName = 'RingEX';
})();
